import { Navigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../redux/store/store";
import { selectAuthData } from "../redux/auth/auth.selectors";
import { loginFromBackoffice } from "../redux/auth/auth.slice";

export type ProtectedRouteProps = {
  isAuthenticated: boolean;
  authenticationPath: string;
  outlet: JSX.Element;
  redirectPath?: string;       // ✅ Add this line
};

// 
export default function ProtectedRoute({authenticationPath, outlet}: ProtectedRouteProps) {

  const dispatch = useAppDispatch();
  const query = new URLSearchParams(window.location.search);
  let token = query.get('token');
  
  // For redirection from HC-Hub (back-office)
  if(token){
    // add/replace user token in the local storage
    dispatch(loginFromBackoffice(token));
  }
  // For redirection from HC-Hub (back-office)
  const authUserData = useAppSelector(selectAuthData);
  // const isPrimaryUser = useAppSelector(checkPrimaryUser);
  // console.log("🚀 ~ ProtectedRoute ~ isPrimaryUser:", isPrimaryUser)
  const isAuthenticated = authUserData || (!!localStorage.getItem('token')) || token;


  // Authorized condition to redirect the user to login
  if(isAuthenticated) {
    return outlet;
  } else if(window.location.pathname !== "/login" && !isAuthenticated){
    return <Navigate to={{ pathname: authenticationPath }} />;
  }else {
    return <Navigate to={{ pathname: "/login" }} />;
  }

  
};